

const ExperienceBox = ({ projectPhoto, projectName }) => {
  const desc = {
    GKCorpName: "Công ty cổ phần công nghệ GK",
    GKCorpDesc:
      "I currently work at GKCorp, a leading technology company, where I've been able to further develop my skills in software engineering. During my time here, I’ve had the opportunity to collaborate with a talented team, tackle challenging projects, and learn from supportive colleagues. The work environment fosters growth, and I continue to expand my technical expertise while contributing to innovative solutions.",
    GKCorpTime: "October 2025 - July 2026",

    JoombookingName: "Joombooking",
    JoombookingDesc:
      "I worked as a fullstack developer at Joombooking, a software company that provides booking solutions for the travel industry. During my time there, I had the opportunity to enhance my coding skills and gain hands-on experience in developing user-friendly web applications tailored to client needs.",
    JoombookingTime: "July 2024 - August 2025",

    NhaphoVNName: "Tập đoàn Nhà Phố Việt Nam",
    NhaphoVNDesc:
      "I used to work for this enterprise, which was the first company I joined. I gained a lot of exprerience during my my time there, working with a greate leader and very kind colleagues who always helped me work effectively when i faced difficulties related to tasks.",
    NhaphoVNTime: "February 2024 - July 2024",
  };


  return (
    <div className="experienceBox">
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <img
          src={projectPhoto}
          className="experiencePhoto"
          alt="Project display"
        />
      </div>
      <div>
        <br />
        <h3>{desc[projectName + "Name"]}</h3>
        <br />
        <p>
          <b>{desc[projectName + "Time"]}</b>
        </p>
        <br />
        {desc[projectName + "Desc"]}
        <br />
      </div>
    </div>
  );
};

export default ExperienceBox;
